import { useState } from 'react';

export function useLoaderControls(initialState = false) {
	const [isLoading, setIsLoading] = useState(initialState);
	return {
		isLoading,
		setIsLoading,
	};
}
